// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"742":"d3c75c52","929":"7c7fdb63"}[chunkId] + ".chunk.css";
};